import { connect } from 'react-redux'

import { ChefPage } from '@components/chef'

import services from '@services'

const mapStateToProps = (state) => {
  const chef = state.chef || {}
  const chefName = [chef.firstName, chef.lastName].filter((n) => n).join(' ')

  return { chefName }
}

const mapDispatchToProps = () => {
  const { UIService } = services

  const newChef = UIService.EditChef.showFoodPartnerModal

  return { newChef }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChefPage)
